import Icon from "@timeedit/ui-components/components/Icon/Icon";
import Language from "../../lib/Language";
import FloatingWindow from "../FloatingWindow";
import AccountContent from "./AccountContent";
import { TOPBAR_BUTTON_ICON_HEIGHT } from "../../lib/UIConstants";

type TTopbarSettingsButtonProps = {
    open: boolean;
    onClose: () => void;
};

const TopbarSettingsWindow = ({ open, onClose }: TTopbarSettingsButtonProps) => {
    return open ? (
        <FloatingWindow
            icon={
                <Icon
                    id="SettingOutlined"
                    style={{ fontSize: TOPBAR_BUTTON_ICON_HEIGHT }}
                    alt={Language.get("nc_settings")}
                />
            }
            title={Language.get("nc_settings")}
            onClose={onClose}
            initialWidth={750}
            initialHeight={540}
            minWidth={520}
            minHeight={350}
        >
            <AccountContent />
        </FloatingWindow>
    ) : null;
};

export default TopbarSettingsWindow;
